import { createContext, useContext } from "react";
import {useSelector} from "react-redux";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const { currentUser } = useSelector(
        (state) => state.common
    );

    return (
        <AuthContext.Provider value={currentUser}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
